import { calculatorDataText } from "./calculator-data-i18n.js";

export function presentCalculatorClaimDateV1(claimDate) {
    if (claimDate === null || claimDate === undefined) {
        return null;
    }
    if (claimDate.precision === "exact") {
        return claimDate.date;
    }
    return calculatorDataText(
        "calculator.data.metadata.claim_date_approximate_value",
        "Approx. { $range }",
        { range: claimDate.range.replace("/", " – ") },
    );
}
